import request from './request'

export function listWageGroup(data) {
  return request.post('/mes/wage-groups/list', data)
}
export function selectWageGroup() {
  return request.get('/mes/wage-groups/select')
}
export function getWageGroup(id) {
  return request.get('/mes/wage-groups/' + id)
}
export function saveWageGroup(data) {
  return request.post('/mes/wage-groups', data)
}
export function updateWageGroup(data) {
  return request.post('/mes/wage-groups/update', data)
}
export function deleteWageGroup(ids) {
  return request.post('/mes/wage-groups/delete', ids)
}
